import { render, staticRenderFns } from "./JWPushMessage.vue?vue&type=template&id=6231eb2a&scoped=true&"
import script from "./JWPushMessage.vue?vue&type=script&lang=js&"
export * from "./JWPushMessage.vue?vue&type=script&lang=js&"
import style0 from "./JWPushMessage.vue?vue&type=style&index=0&id=6231eb2a&prod&scoped=true&lang=css&"
import style1 from "./JWPushMessage.vue?vue&type=style&index=1&id=6231eb2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6231eb2a",
  null
  
)

export default component.exports